import { useQuery } from "@tanstack/react-query";
import { credentialsService } from "@/api/credentials";

export const useCredentials = () => {
    return useQuery({
        queryKey: ["public-credentials"],
        queryFn: () => credentialsService.getPublicCredentials(),
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes cache
        placeholderData: {
            companyName: "Tale Platform SAS",
            address: "123 Avenue des Champs-Élysées, 75008 Paris, France",
            phoneNumber: "+33 1 23 45 67 89",
            taxId: "FR12345678901"
        }
    });
};
